import ApplicationController from '../application_controller'
import { HEADERS } from 'appConstants'

class MsTeamsMeetingController extends ApplicationController {
  static values = { appointmentTypeId: String }
  static targets = [
    'appointmentType',
    'startTime',
    'duration',
    'msTeamsMeetingBlock',
    'generateLinkBlock',
    'meetingLinkBlock',
    'form'
  ]

  connect () {
    $(this.appointmentTypeTarget).on('change', this.appointmentTypeChange.bind(this))
  }

  appointmentTypeChange (event) {
    if (!this.hasMsTeamsMeetingBlockTarget) return

    const value = $(event.target).val()
    if (value !== '' && value === this.appointmentTypeIdValue) {
      this.msTeamsMeetingBlockTarget?.classList?.remove('d-none')
    } else {
      this.msTeamsMeetingBlockTarget?.classList?.add('d-none')
    }
  }

  copyToClipboard () {
    const meetingUrl = this.meetingLinkBlockTarget.querySelector('#meetingUrl')?.querySelector('a')
    navigator
      .clipboard
      .writeText(meetingUrl?.href)
      .catch(err => console.error('Could not copy text: ', err))

    document.getElementById('copy_link').classList.add('d-none')
    document.getElementById('copied_link').classList.remove('d-none')
    setTimeout(() => {
      document.getElementById('copy_link').classList.remove('d-none')
      document.getElementById('copied_link').classList.add('d-none')
    }, 2000)
  }

  generateLink (event) {
    if (this.startTimeTarget.value === '') {
      document.querySelectorAll('.flatpickr-confirm').forEach(el => {
        if (el.querySelector('span.flatpickr_confirm_appointment_starttime')) {
          el.addEventListener('click', () => {
            if (document.querySelector('#generateLinkId').dataset.firstSelectDatetime === 'true') {
              this.generateLink()
            }
          })
        }
      })

      event.target.setAttribute('data-first-select-datetime', 'true')
      this.startTimeTarget.focus()
    } else {
      this.generateLinkBlockTarget.querySelector('#generateLinkId').classList.add('d-none')
      this.generateLinkBlockTarget.querySelector('#loaderId').classList.remove('d-none')

      fetch('/users/ms_teams_meeting_create',
        {
          headers: HEADERS,
          method: 'POST',
          body: JSON.stringify({
            start_time: this.startTimeTarget.value,
            duration: this.durationTarget.value
          })
        }
      ).then(response => {
        if (response.status !== 200) throw new Error(response.status)
        return response.json()
      }).then(responseJson => this._showMeetingLinkBlock(responseJson))
        .catch(error => {
          console.error('Error:', error)
          $.growlyflash({ msg: I18n.t('something_goes_wrong'), type: 'danger' })
        })
    }
  }

  _showMeetingLinkBlock (data) {
    this.generateLinkBlockTarget.querySelector('#loaderId').classList.add('d-none')
    this.generateLinkBlockTarget.classList.add('d-none')
    this.meetingLinkBlockTarget.classList.remove('d-none')
    const meetingId = this.meetingLinkBlockTarget.querySelector('#meetingId')
    const meetingUrl = this.meetingLinkBlockTarget.querySelector('#meetingUrl')
    const link = document.createElement('a')

    meetingId.textContent = I18n.t('ms_teams.meeting_id', { meeting_id: data.meeting_id })
    link.href = data.join_web_url
    link.textContent = I18n.t('ms_teams.join_the_meeting_now')
    link.target = '_blank'
    meetingUrl.appendChild(link)

    this._add_hidden_input(data)
  }

  _add_hidden_input (data) {
    [
      ['ms_teams_meeting_id', data.meeting_id],
      ['ms_teams_join_web_url', data.join_web_url]
    ].forEach(item => {
      const hiddenInput = document.createElement('input')
      hiddenInput.type = 'hidden'
      hiddenInput.name = `${item[0]}`
      hiddenInput.value = item[1]
      this.formTarget.appendChild(hiddenInput)
    })
  }
}

export default MsTeamsMeetingController
